export default "__VITE_ASSET__DHxbmOQf__"